export interface ErrorContent {
  heading: string;
  body: string;
}

export enum ErrorCodes {
  UNKNOWN = 'UNKNOWN',
  PROPOSAL_EXPIRED = 'PROPOSAL_EXPIRED',
  DOCUMENT_SHARING_EXPIRED = 'DOCUMENT_SHARING_EXPIRED',
  NOT_FOUND = 'NOT_FOUND',
  SSO_MULTIPLE_ORGANIZATIONS = 'SSO_MULTIPLE_ORGANIZATIONS',
  SSO_MULTIPLE_TENANTS_FOR_ORGANIZATION = 'SSO_MULTIPLE_TENANTS_FOR_ORGANIZATION',
  SSO_NO_ACCESSIBLE_TENANTS_FOR_ORGANIZATION = 'SSO_NO_ACCESSIBLE_TENANTS_FOR_ORGANIZATION',
}

export const ERROR_CONTENT: Record<ErrorCodes, ErrorContent> = {
  [ErrorCodes.UNKNOWN]: {
    heading: 'An error occurred',
    body: `Something unexpected happened. We were automatically notified, and we'll be looking into it shortly.`,
  },
  [ErrorCodes.DOCUMENT_SHARING_EXPIRED]: {
    heading: 'This document sharing link has expired',
    body: `Please reach out to your primary contact for assistance`,
  },
  [ErrorCodes.PROPOSAL_EXPIRED]: {
    heading: 'This proposal has expired',
    body: `Please reach out to your primary contact for assistance`,
  },
  [ErrorCodes.NOT_FOUND]: {
    heading: `We can't find this page`,
    body: `We weren't able to find a page associated with this link. Please try to find this content in another way or reach out to your primary contact for assistance.`,
  },
  [ErrorCodes.SSO_MULTIPLE_ORGANIZATIONS]: {
    heading: 'Multiple organizations detected',
    body: `You belong to multiple organizations. Please sign in from your specific tenant URL (e.g., yourcompany.luminary.com) instead of using IDP-initiated SSO.`,
  },
  [ErrorCodes.SSO_MULTIPLE_TENANTS_FOR_ORGANIZATION]: {
    heading: 'Multiple organizations detected',
    body: `You belong to multiple organizations. Please sign in from your specific tenant URL (e.g., yourcompany.luminary.com) instead of using IDP-initiated SSO.`,
  },
  [ErrorCodes.SSO_NO_ACCESSIBLE_TENANTS_FOR_ORGANIZATION]: {
    heading: 'No accessible workspaces',
    body: 'Your organization does not have any workspaces that you can access. Contact your administrator for assistance.',
  },
};
